<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer
        :title="prefix + title">
        <AvaliacaoEstadoConservacaoList :prefix="prefix" :id="id"></AvaliacaoEstadoConservacaoList>
    </b-modal>
</template>

<script>

import AvaliacaoEstadoConservacaoList from '@/modules/patrimonio/avaliacao-estado-conservacao/AvaliacaoEstadoConservacaoList.vue';

export default {
    name: "ModalEstadoConservacaoIBP",
    components: {
        AvaliacaoEstadoConservacaoList
    },
    props: {
        prefix: {
            type:String,
            default: ""
        },
        id: Number,
    },
    data() {
        return {
            title: "Avaliação de Estado de Conservação",
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>